<script lang="ts">
  // component
  import BannerBase from "@retailer/svelte/Payments/Banners/Base.svelte";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";

  // props
  export let handleBannerClose: (type: string) => {};

  // data
  const autoPayBannerType = "auto_pay_banner";

</script>

<div class="fizz-container fizz-stack-24">
  <div class="fizz-flex-item" data-testid={autoPayBannerType}>
    <BannerBase
      height={60}
      width={60}
      iconType={"Cash"}
      heading="Enroll in Autopay"
      onClose={() => handleBannerClose(autoPayBannerType)}
    >
      <p class="fizz-text-medium">
        Pro tip:
        <UIRouterLink stateName={`layout.invoice_settings`} classes={"fizz-text-medium"}>
          Set up AutoPay, save time, and never miss a payment.
        </UIRouterLink>
      </p>
    </BannerBase>
  </div>
</div>
